// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1e9IW","content":"styles_content__Pyj-1","tableWrap":"styles_tableWrap__3aaYz"};